export default __webpack_public_path__ + "static/media/pana.13e3bbfb.svg";